/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
export var AccommodationType;
(function (AccommodationType) {
    AccommodationType["HOTEL"] = "HOTEL";
    AccommodationType["AIRBNB"] = "AIRBNB";
    AccommodationType["OTHER"] = "OTHER";
})(AccommodationType || (AccommodationType = {}));
export var CostDistributionType;
(function (CostDistributionType) {
    CostDistributionType["PER_PERSON"] = "PER_PERSON";
    CostDistributionType["TOTAL"] = "TOTAL";
})(CostDistributionType || (CostDistributionType = {}));
export var ModelAttributeTypes;
(function (ModelAttributeTypes) {
    ModelAttributeTypes["binary"] = "binary";
    ModelAttributeTypes["binarySet"] = "binarySet";
    ModelAttributeTypes["bool"] = "bool";
    ModelAttributeTypes["list"] = "list";
    ModelAttributeTypes["map"] = "map";
    ModelAttributeTypes["number"] = "number";
    ModelAttributeTypes["numberSet"] = "numberSet";
    ModelAttributeTypes["string"] = "string";
    ModelAttributeTypes["stringSet"] = "stringSet";
    ModelAttributeTypes["_null"] = "_null";
})(ModelAttributeTypes || (ModelAttributeTypes = {}));
export var PostType;
(function (PostType) {
    PostType["ACTIVITY"] = "ACTIVITY";
    PostType["ACCOMMODATION"] = "ACCOMMODATION";
    PostType["FLIGHT"] = "FLIGHT";
    PostType["TRANSPORTATION"] = "TRANSPORTATION";
})(PostType || (PostType = {}));
export var TransportationType;
(function (TransportationType) {
    TransportationType["RENTAL_CAR"] = "RENTAL_CAR";
    TransportationType["RIDE_SHARING"] = "RIDE_SHARING";
    TransportationType["PUBLIC_TRANSPORTATION"] = "PUBLIC_TRANSPORTATION";
    TransportationType["OTHER"] = "OTHER";
})(TransportationType || (TransportationType = {}));
export var PermissionType;
(function (PermissionType) {
    PermissionType["OWNER"] = "OWNER";
    PermissionType["VIEWER"] = "VIEWER";
    PermissionType["MEMBER"] = "MEMBER";
    PermissionType["EDITOR"] = "EDITOR";
})(PermissionType || (PermissionType = {}));
export var FeedbackCategory;
(function (FeedbackCategory) {
    FeedbackCategory["ISSUE"] = "ISSUE";
    FeedbackCategory["INQUIRY"] = "INQUIRY";
    FeedbackCategory["FEEDBACK"] = "FEEDBACK";
})(FeedbackCategory || (FeedbackCategory = {}));
export var FriendshipRequestType;
(function (FriendshipRequestType) {
    FriendshipRequestType["ADD"] = "ADD";
    FriendshipRequestType["BLOCK"] = "BLOCK";
    FriendshipRequestType["ACCEPT"] = "ACCEPT";
    FriendshipRequestType["REMOVE"] = "REMOVE";
    FriendshipRequestType["DENY"] = "DENY";
})(FriendshipRequestType || (FriendshipRequestType = {}));
export var NotificationSettingType;
(function (NotificationSettingType) {
    NotificationSettingType["NO_NOTIFICATION"] = "NO_NOTIFICATION";
    NotificationSettingType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
    NotificationSettingType["EMAIL_NOTIFICATION"] = "EMAIL_NOTIFICATION";
    NotificationSettingType["PUSH_AND_EMAIL_NOTIFICATION"] = "PUSH_AND_EMAIL_NOTIFICATION";
})(NotificationSettingType || (NotificationSettingType = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["FRIENDSHIP_ADD"] = "FRIENDSHIP_ADD";
    NotificationType["FRIENDSHIP_BLOCK"] = "FRIENDSHIP_BLOCK";
    NotificationType["FRIENDSHIP_REMOVE"] = "FRIENDSHIP_REMOVE";
    NotificationType["TRIP_MEMBER_ADD"] = "TRIP_MEMBER_ADD";
    NotificationType["TRIP_MEMBER_REMOVE"] = "TRIP_MEMBER_REMOVE";
    NotificationType["TRIP_MEMBER_PERMISSION_CHANGE"] = "TRIP_MEMBER_PERMISSION_CHANGE";
    NotificationType["TRIP_POST_NEW"] = "TRIP_POST_NEW";
    NotificationType["TRIP_POST_REMOVE"] = "TRIP_POST_REMOVE";
    NotificationType["POST_LIKE"] = "POST_LIKE";
    NotificationType["POST_UNLIKE"] = "POST_UNLIKE";
    NotificationType["POST_COMMENT"] = "POST_COMMENT";
    NotificationType["POST_PARTICIPANT_ADD"] = "POST_PARTICIPANT_ADD";
    NotificationType["POST_PARTICIPANT_REMOVE"] = "POST_PARTICIPANT_REMOVE";
    NotificationType["POST_UPDATE"] = "POST_UPDATE";
    NotificationType["COMMENT_REPLY"] = "COMMENT_REPLY";
    NotificationType["COMMENT_LIKE"] = "COMMENT_LIKE";
    NotificationType["COMMENT_UNLIKE"] = "COMMENT_UNLIKE";
    NotificationType["COMMENT_DELETE"] = "COMMENT_DELETE";
    NotificationType["TRIP_INVITATION"] = "TRIP_INVITATION";
})(NotificationType || (NotificationType = {}));
export var NotificationStatusType;
(function (NotificationStatusType) {
    NotificationStatusType["ACTIVE"] = "ACTIVE";
    NotificationStatusType["VIEWED"] = "VIEWED";
    NotificationStatusType["HIDDEN"] = "HIDDEN";
    NotificationStatusType["PASSIVE"] = "PASSIVE";
})(NotificationStatusType || (NotificationStatusType = {}));
export var TripInvitationStatus;
(function (TripInvitationStatus) {
    TripInvitationStatus["ACCEPTED"] = "ACCEPTED";
    TripInvitationStatus["REJECTED"] = "REJECTED";
    TripInvitationStatus["PENDING"] = "PENDING";
})(TripInvitationStatus || (TripInvitationStatus = {}));
export var FriendshipStatusType;
(function (FriendshipStatusType) {
    FriendshipStatusType["ACCEPTED"] = "ACCEPTED";
    FriendshipStatusType["PENDING"] = "PENDING";
    FriendshipStatusType["BLOCKED"] = "BLOCKED";
})(FriendshipStatusType || (FriendshipStatusType = {}));
export var ModelSortDirection;
(function (ModelSortDirection) {
    ModelSortDirection["ASC"] = "ASC";
    ModelSortDirection["DESC"] = "DESC";
})(ModelSortDirection || (ModelSortDirection = {}));
